import { createFileRoute } from '@tanstack/react-router';
import { TemplateDraftEditorPage } from '../features/templates/template-draft-editor-page';
export const Route = createFileRoute('/manage/$companySlug/templates_/$templateId/drafts/$draftId')(
  { component: RouteComponent },
);
function RouteComponent() {
  const { companySlug, draftId, templateId } = Route.useParams();
  return (
    <TemplateDraftEditorPage companySlug={companySlug} draftId={draftId} templateId={templateId} />
  );
}
